module.exports = __webpack_public_path__ + "img/lg_ring_g_l_1_1@2x.5373abf2.png";